const now = new Date();
const localTimezoneOffset = (now.getTimezoneOffset() / 60) * -1;

export const dateFormat = (date?: Date | string, symbol = "-", time = localTimezoneOffset) => {
  const currentDate = date ? new Date(date) : new Date();
  currentDate.setHours(currentDate.getHours() + time);

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");

  const formattedDate = `${year}${symbol}${month}${symbol}${day} ${hours}:${minutes}:${seconds}`;
  return formattedDate;
};

// toIOSString -> Date 타입으로 변환
export const formatDateForInput = (date: string): string => {
  const d = new Date(date);
  const offset = d.getTimezoneOffset() * 60000;
  const localDate = new Date(d.getTime() - offset).toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"
  return localDate;
};
